
define('text!modules/targeting/siteList/templates/panel.html',[],function () { return '<div class="w-box w-SiteListTargeting">\n\t<div class="w-panel-body w-body"></div>\n\t<div class="w-foot">{{>footer}}</div>\n</div>\n';});

